/**
 * WebSearch API スキーマ
 *
 * Brave Web Search API をバックエンド経由で呼び出すエンドポイント
 *  - GET  /web-search → WebSearchAvailabilityResponseSchema
 *  - POST /web-search → WebSearchRequestSchema → WebSearchResponseSchema
 *
 * Brave 由来の生メタデータ（画像サムネイル・トラッキング ID 等）を
 * ツール結果に混入させないため、許可リスト射影で `title` / `url` / `description`
 * のみをスキーマに含める。
 */
import { z } from 'zod';
// ========================================
// GET /web-search: キャパビリティ
// ========================================
export const WebSearchAvailabilityResponseSchema = z.object({
    available: z.boolean(),
});
// ========================================
// POST /web-search: リクエスト
// ========================================
export const WebSearchRequestSchema = z.object({
    query: z
        .string()
        .trim()
        .min(1)
        .max(400)
        .describe('Search keywords (1-400 characters, whitespace trimmed).'),
    count: z
        .number()
        .int()
        .min(1)
        .max(20)
        .default(10)
        .describe('Number of results to return (1-20). Default: 10.'),
});
// ========================================
// POST /web-search: レスポンス
// ========================================
/**
 * 許可リスト型: `title` / `url` / `description` 以外は Zod の strip で落とす。
 * Zod の既定は `strip` のため passthrough を使わない。
 */
export const WebSearchResultItemSchema = z.object({
    title: z.string(),
    url: z.string().url(),
    description: z.string().default(''),
});
export const WebSearchErrorTypeSchema = z.enum([
    'auth',
    'rate_limit',
    'http',
    'timeout',
    'network',
    'unknown',
]);
export const WebSearchSuccessResponseSchema = z.object({
    status: z.literal('success'),
    results: z.array(WebSearchResultItemSchema),
});
export const WebSearchErrorResponseSchema = z.object({
    status: z.literal('error'),
    errorType: WebSearchErrorTypeSchema,
    upstreamStatusCode: z.number().int().optional(),
    retryAfterSeconds: z.number().int().optional(),
    message: z.string(),
});
export const WebSearchResponseSchema = z.discriminatedUnion('status', [
    WebSearchSuccessResponseSchema,
    WebSearchErrorResponseSchema,
]);
//# sourceMappingURL=web-search-schemas.js.map